import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hrm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// انتهاء الجلسة (أو تغيير كلمة المرور من جهاز آخر) يعيد المستخدم إلى صفحة الدخول
const AUTH_SAFE = ["/auth/login", "/auth/register", "/auth/change-password"];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const businessAuthCall = AUTH_SAFE.some((u) => url.includes(u));
    if (status === 401 && !businessAuthCall && localStorage.getItem("hrm_token")) {
      localStorage.removeItem("hrm_token");
      if (!window.location.pathname.startsWith("/login")) window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export default api;
